import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useBoardLogic } from './BoardLogic';
import BasicBoardSkin from './skins/BasicBoardSkin';

/**
 * Board 컴포넌트의 스킨 시스템 정의
 */
export const BoardSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.BOARD,
  name: '게시판',
  category: 'content',
  icon: '📋',
  supportsExternalSkins: true,
  options: [
    {
      type: 'text',
      label: '게시판 제목',
      key: 'title',
      default: '게시판'
    },
    {
      type: 'text',
      label: '게시판 파라미터 (카테고리 ID)',
      key: 'parameter',
      default: ''
    },
    {
      type: 'checkbox',
      label: '새 글 작성 버튼 표시',
      key: 'showNewButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '수정하기 버튼 표시',
      key: 'showEditButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '삭제하기 버튼 표시',
      key: 'showDeleteButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '댓글 작성 버튼 표시',
      key: 'showCommentButton',
      default: true
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicBoardSkin
  },
  useLogic: useBoardLogic,
  defaultProps: {
    id: '',
    style: {
      width: '100%',
      minHeight: '400px',
      padding: '20px',
      backgroundColor: '#ffffff'
    },
    data: {
      title: '게시판',
      parameter: '',
      showNewButton: true,
      showEditButton: true,
      showDeleteButton: true,
      showCommentButton: true,
      device: {
        pc: {
          title: '게시판',
          showNewButton: true,
          showEditButton: true,
          showDeleteButton: true,
          showCommentButton: true
        },
        mobile: {
          title: '게시판',
          showNewButton: true,
          showEditButton: true,
          showDeleteButton: true,
          showCommentButton: true
        }
      }
    }
  }
};